<template>
  <highcharts :options="this.chartOptions"></highcharts>
</template>

<script>
// import moment from 'moment';
import Highcharts, { dateFormat } from "highcharts";
import exportingInit from "highcharts/modules/exporting";

exportingInit(Highcharts);

export default {
  props: ["xAxis", "yAxis", "name", "title", "fromModal"],
  // xAxis: {
  //   type: Array,
  //   default: function () {
  //     return [1, 2, 3, 4, 5];
  //   },
  // },
  // yAxis: {
  //   type: Array,
  //   default: function () {
  //     return [23, 24, 25, 26, 67];
  //   },
  // },
  // name: {
  //   type: String,
  //   default: function () {
  //     return 'Pollutant';
  //   },
  // },
  // title: {
  //   type: String,
  //   default: function () {
  //     return 'Pollutant';
  //   },
  // },
  // fromModal: {
  //   type: Number,
  //   default: function () {
  //     return 0;
  //   },
  //   },
  // },
  data() {
    return {
      chartOptions: {
        chart: {
          height: "30%",
          zoomType: "xY",
        },
        credits: {
          enabled: false,
        },
        title: {
          text: '',
        },

        colors: ["#80bfff"],
        time: {
          useUTC: false,
        },

        exporting: { enabled: false },
        xAxis: {
          minorGridLineWidth: 0,
          lineColor: "grey",
          lineWidth: 1,
          // type: "datetime",
          // dateTimeLabelFormats: {
          //   day: '%H of %e of %b'
          // },
          labels: {
            enabled: false,
          },
        },
        yAxis: {
          min: 0,
          gridLineWidth: 1,
          title: {
            text: "",
            align: "high",
          },
          labels: {
            align: "right",
            x: -3,
            y: 16,
            format: "{value:.,0f}",
          },
        },
        // tooltip: {
        //   formatter: function () {
        //     return (
        //       "<b>" +
        //       this.series.name +
        //       ":" +
        //       this.y +
        //       "</b><br/>" +
        //       Highcharts.dateFormat(
        //         "%e of %b %Y, %I:%M %p",
        //         (this.x)
        //       )
        //     );
        //   },
        // },
        title: {
          text: this.title,
          //   align: 'left',
          //   x: 0,
          //   y: 23
          style: {
            color: "#677dab",
            fontWeight: "bold",
            fontSize: 15,
          },
        },

        plotOptions: {
          series: {
            lineWidth: 1.5,
            marker: {
              enabled: false,
              radius: 1,
            },
          },
        },

        series: [
          {
            name: this.name,
            type: "line",
            allowPointSelect: true,
            data: this.yAxis,
            // pointStart: moment(new Date(this.value)).format("DD MMM hh:mm A"),
            // pointInterval: 24, //* 3600 * 1000,  one day
            pointPadding: 0,
            groupPadding: 0.1,
            showInLegend: false,
          },
        ],
      },
    };
  },

  // watch: {
  //   yAxis(newValue, oldValue) {
  //     this.chartOptions.series[0].data = newValue;
  //   },
  //   name(newValue, oldValue) {
  //     this.chartOptions.series[0].name = newValue;
  //   },
  //   // xAxis: function(newValue, oldValue) {
  //   //   this.xAxis.categories = newValue;
  //   // }
  // },
  watch: {
    yAxis: {
      immediate: true,
      handler(v) {
        this.chartOptions.series[0].data = v;
      },
    },
    name(newValue, oldValue) {
      this.chartOptions.series[0].name = newValue;
    },
    title:{
      immediate : true,
      handler(v){
        this.chartOptions.title.text = v;
      }
    }
  },
};
</script>
<style>
</style>
